function CardIcon({ sizeNum = 2 }) {
  const sizeStyle = { width: `${sizeNum}rem`, height: `${sizeNum}rem` };
  return (
    <svg
      style={sizeStyle}
      className={`flex-shrink-0 size-10 sm:block text-gray-800 dark:text-gray-200`}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth=".5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g>
        <path
          className="fill-white"
          d="M22.6,19H1.4C0.63,19,0,18.37,0,17.6V5.4C0,4.63,0.63,4,1.4,4h21.2C23.37,4,24,4.63,24,5.4v12.2
          C24,18.37,23.37,19,22.6,19z"
        />
      </g>
      <line x1="2.88" y1="5.9" x2="11.03" y2="5.9" />
      <line x1="17.01" y1="5.9" x2="22.08" y2="5.9" />
      <polyline points="2.88,8.45 14.34,8.45 2.97,13.54 14.34,13.54 " />
      <rect x="2" y="15" width="13" height="2" />
      <line x1="4.28" y1="15" x2="4.28" y2="16.95" />
      <line x1="6.43" y1="15" x2="6.43" y2="16.95" />
      <line x1="8.59" y1="15" x2="8.59" y2="16.95" />
      <line x1="10.74" y1="15" x2="10.74" y2="16.95" />
      <line x1="12.89" y1="15" x2="12.89" y2="16.95" />
      <rect
        x="19"
        y="14"
        className="fill-red-400 stroke-0"
        width="3"
        height="3"
      />
    </svg>
  );
}

export default CardIcon;
